<div class="modalSustainability vc-modal__innerContainer vc-text-m">
  <button aria-label="close modal" class="vc-modal__closeBtn vc-modal__closeBtn--withText" [mat-dialog-close]>
    <span i18n="@@MODAL.BUTTON.CLOSE" class="vc-modal__closeBtn__text">Close</span>
    <vc-sprite-icons class="vc-modal__closeBtn__smallCross" name="cross-x-thick"></vc-sprite-icons>
  </button>

  <h3 class="modalSustainability__title vc-title-xs">
    <vc-sprite-icons class="modalSustainability__title__icon" name="sustainable-leaf"></vc-sprite-icons>
    <span i18n="@@INFO_LEAF_MODAL.SUSTAINABLE_LEAF.TITLE1"><span lang="en">Sustainable</span></span>
  </h3>
  <p class="modalSustainability__intro" i18n="@@INFO_LEAF_MODAL.SUSTAINABLE_LEAF.TEXT1">
    Want to reduce your carbon footprint when shopping? Here are some quick tips!
  </p>
  <ul class="modalSustainability__list">
    <li class="modalSustainability__list__item">
      <b>{{ localFilterTitle }}: </b>
      <span i18n="@@INFO_LEAF_MODAL.SUSTAINABLE_LEAF.TEXT2">
        This only shows items in your region, so your orders will have shorter distances to travel to reach your
        wardrobe!
      </span>
    </li>
    <li class="modalSustainability__list__item">
      <b i18n="@@INFO_LEAF_MODAL.SUSTAINABLE_LEAF.TITLE3"> Direct Shipping: </b>&nbsp;<span
        i18n="@@INFO_LEAF_MODAL.SUSTAINABLE_LEAF.TEXT4"
      >
        Your item will be delivered directly to you (last year our community eliminated over 300,000 shipments through
        our hubs)
      </span>
    </li>
  </ul>
</div>
